import { logError, logWarning } from '../../shared/logger';
import {
  DefaultQueryParams,
  DeprecatedQueryParams,
  QueryParams,
} from '../../shared/types/DefaultQueryParams';

const deprecations: Record<keyof DeprecatedQueryParams, keyof QueryParams> = {
  adults: 'passengerAges',
  children: 'passengerAges',
  cmp: 'siteLoc',
  cur: 'currency',
  date_from: 'depDate',
  entityId: 'extra_hotelId',
  infants: 'passengerAges',
  oneWay: 'retDate',
  partner_visitor_id: 'trackInfo',
  position_id: 'tarPosId',
  seniors: 'passengerAges',
  sortingOrder: 'extra_sortingOrder',
  youths: 'passengerAges',
};

export const warnOfDeprecations = (data: DefaultQueryParams): void => {
  try {
    Object.keys(deprecations).forEach((deprecatedKey) => {
      const newKey = deprecations[deprecatedKey];
      const deprecatedValue = data[deprecatedKey];

      if (deprecatedValue) {
        const newValue = data[newKey];
        const message = `${deprecatedKey} is deprecated, please use ${newKey} instead.`;

        logWarning(message, {
          deprecatedKey,
          deprecatedValue,
          newKey,
          newValue,
        });
      }
    });
  } catch (error) {
    const message = (error && (error as Error)?.message) || 'Unknown';

    logError(`Warning of deprecations failed with error: ${message}`);
  }
};
